import dynamic from "next/dynamic";
export const BuilderContentBlocks = dynamic(() => import("./component"));
